'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'swords-laser';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e03d';
var svgPathData = ['M37.2-4.5L283.8 272 387.6 272 59.7-26.8c-6.3-5.7-15.9-5.5-21.9 .5-5.9 5.9-6.2 15.5-.6 21.7zM352.1 165.1l60.5 55.2 .7-.7-7.8-7.1 189.7-209.1c5.6-6.2 5.4-15.8-.5-21.7s-15.5-6.2-21.7-.5l-211.2 191.5-8.9-8.1-.7 .6z', 'M37.8-26.3c-5.9 5.9-6.2 15.5-.6 21.7L283.8 272 387.6 272 59.7-26.8c-6.3-5.7-15.9-5.5-21.9 .5zM70.4-38.6L411.3 272 419 272c8.5 0 16.6 3.4 22.6 9.4l176 176c12.5 12.5 12.5 32.8 0 45.3l-50.7 50.7c-12.5 12.5-32.8 12.5-45.3 0-155.7-155.7-110.5-110.5-262.1-262.1-2.1-2.1-3.3-5-3.3-8 0-4.7 2.9-8.7 6.9-10.4L25.3 6.1c-11.2-12.6-10.7-31.8 1.2-43.7 12-12 31.4-12.5 43.9-1zM532.9 542.1c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7-111-111-31 31 99.7 99.7zm53.7-31l19.7-19.7c6.2-6.2 6.2-16.4 0-22.6l-99.7-99.7-31 31 111 111zM421.9 431l73.4-73.4-65-65c-3-3-7.1-4.7-11.3-4.7l-140.1 0 143 143zM33.2 451.7l177.5-177.5 5.6 6.3c-.1 1-.1 1.9-.1 2.9 0 2.5 .2 5 .5 7.5l-21.2 21.2 68.7 68.7 14.1-14.1 11.3 11.3-165.1 165.1c-15.6 15.6-40.9 15.6-56.6 0L33.2 508.3c-15.6-15.6-15.6-40.9 0-56.6zM607 14.1L417.3 223.3 405.4 212.5 595.1 3.4c5.6-6.2 5.4-15.8-.5-21.7s-15.5-6.2-21.7-.5L361.7 172.7 349.8 161.8 562.1-30.7c12.5-11.4 31.8-10.9 43.8 1.1S618.4 1.6 607 14.1zM147.6 360l68.7 68.7 36.7-36.7-68.7-68.7-36.7 36.7zm-11.3 11.3L44.5 463c-9.4 9.4-9.4 24.6 0 33.9l34.7 34.7c9.4 9.4 24.6 9.4 33.9 0l91.7-91.7-68.7-68.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwordsLaser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;